/**
 * @file コンポーネント：フル動画ページタイムライン ロジック管理
 */

// ライブラリ読み込み
import React, { useEffect, useRef, useState } from "react";

// 関数読み込み
import { fnSendEventHubspot } from "~/src/functions/hubspot";

// Presenter読み込み
import { Presenter } from "./presenter";

// コンポーネントを返す
export const Timeline = (props) => {
    /**
     * タイムラインの時間のみ格納した配列を生成
     */
    const [listTimelineTime, setListTimelineTime] = useState([]);
    useEffect(() => {
        if (props.listTimeline && props.listTimeline.length > 0) {
            // props.listTimelineが空でない場合のみ時間格納処理開始
            const result = [];
            props.listTimeline.forEach((item) => {
                if (item.listTopic) {
                    // トピックリストがある場合、トピックリスト内の各コメントの時間を格納
                    result.push(item.time);
                    item.listTopic.forEach((topic) => {
                        result.push(topic.time);
                    });
                } else {
                    result.push(item.time);
                }
            });
            setListTimelineTime(result);
        }
    }, [props.listTimeline]);

    /**
     * 再生時間更新時にタイムラインの該当の執刀医コメント位置までスクロールする
     */
    const refTimeline = useRef(null); // タイムライン
    useEffect(() => {
        // 有料コンテンツかつ未購入の場合、フル動画が無いので処理しない
        if (!(props.isPaid === true && props.isPurchased === false)) {
            // refの存在確認とタイムラインが空なら処理しない
            if (
                listTimelineTime.length > 0 &&
                refTimeline &&
                refTimeline.current
            ) {
                const index = listTimelineTime.indexOf(props.timeProgress); // 再生時間が一致する執刀医コメントの位置
                // 再生時間が一致する執刀医コメントがあればスクロール処理する
                if (index !== -1) {
                    // 再生時間が一致する執刀医コメントのクラスに"is-close"が存在したら処理しない
                    const classNames = Array.from(
                        refTimeline.current.children[index]?.classList
                    );
                    if (classNames && classNames.indexOf("is-close") === -1) {
                        const contentlist = // タブコンテンツ
                            refTimeline.current.parentElement.parentElement
                                .parentElement;
                        const contentlistY = // スクロール枠位置
                            contentlist.getBoundingClientRect().top;
                        const commentY = // 執刀医コメント位置
                            refTimeline.current.children[
                                index
                            ].getBoundingClientRect().top;
                        const positionY = commentY - contentlistY; // スクロール量
                        contentlist.scrollBy({
                            behavior: "smooth",
                            top: positionY,
                        });
                        // スクロール時に3秒間アクティブstyleを適用する
                        refTimeline.current.children[
                            index
                        ].children[0].classList.add("is-active");
                        setTimeout(() => {
                            refTimeline.current.children[
                                index
                            ].children[0].classList.remove("is-active");
                        }, 3000);
                    }
                }
            }
        }
    }, [props.timeProgress, listTimelineTime, refTimeline]);

    /**
     * タイムライン最後の執刀医コメントのstyleを設定（スクロール時に執刀医コメントが一番上に来るようにstyleを調整）
     */
    useEffect(() => {
        if (
            props.isShow === true &&
            props.listTimeline.length > 0 &&
            refTimeline &&
            refTimeline.current
        ) {
            // 表示中かつprops.listTimelineが空でない場合のみ
            // styleのリセット
            Array.from(refTimeline.current.children).forEach(
                (item: HTMLLIElement) => {
                    item.style.marginBottom = "";
                }
            );
            // タブコンテンツの高さ取得
            const contentlist =
                refTimeline.current.parentElement.parentElement.parentElement; // タブコンテンツ
            const heightContent = contentlist.getBoundingClientRect().height;
            // 最後のコメントの高さ取得し、margin-bottomをセット
            const comment = Array.from(refTimeline.current.children).slice(
                -1
            )[0] as HTMLLIElement;
            const images = comment.querySelectorAll("img");
            if (images.length > 0) {
                // コメントに画像が含まれる場合、全ての画像読み込み完了後に処理
                let countLoaded = 0;
                images.forEach((image) => {
                    image.addEventListener(
                        "load",
                        () => {
                            countLoaded++;
                            if (countLoaded === images.length) {
                                const heightComment = comment.clientHeight;
                                const margin = heightContent - heightComment;
                                if (margin > 0) {
                                    comment.style.marginBottom = margin + "px";
                                }
                            }
                        },
                        { once: true }
                    );
                });
            } else {
                // コメントに画像が含まれない場合、すぐに処理
                const heightComment = comment.clientHeight;
                const margin = heightContent - heightComment;
                if (margin > 0) {
                    comment.style.marginBottom = margin + "px";
                }
            }
        }
    }, [props.isShow, props.listTimeline, refTimeline]);

    /**
     * コメントボタンクリック時の処理
     */
    const fnOnClickButton = (time, text) => {
        if (!window.dataUser.isLogin) {
            // 非ログイン時にログインモーダルを出す
            props.setIsOpenModalLogin(true);
        } else if (props.isPaid === true && props.isPurchased === false) {
            // 有料コンテンツかつ未購入の場合、決済情報ポップアップを強調表示
            props.setIsHighlightPopupPayment(true);
        } else {
            // 有料コンテンツでない、または購入済みの場合、執刀医コメントの該当時間にジャンプする
            // HubSpotにイベントを送信
            fnSendEventHubspot({
                name: "pe21169348_chapter",
                properties: {
                    itme: time,
                    label: text,
                },
            });
            // フル動画タブに切り替え
            props.setSelectedContentsData("fullvideo");
            // 該当時間にジャンプ
            props.fnJump(time);
        }
    };

    /**
     * タイムライン用サムネイルの処理
     */
    //// VTT の1行を解析して { start, end, src, x, y, w, h } を返す
    //function parseVttLine(line: string) {
    //    const match = line.match(/(.*)#xywh=(\d+),(\d+),(\d+),(\d+)/);
    //    if (!match) return null;

    //    return {
    //        src: match[1].trim(),
    //        x: parseInt(match[2], 10),
    //        y: parseInt(match[3], 10),
    //        w: parseInt(match[4], 10),
    //        h: parseInt(match[5], 10),
    //    };
    //}

    //// VTTをロード＆パース
    //async function loadThumbnails(vttUrl: string) {
    //    const res = await fetch(vttUrl);
    //    const text = await res.text();
    //    const lines = text.split("\n");

    //    const thumbnails: { start: number; end: number; sprite: any }[] = [];
    //    let currentStart: number | null = null;

    //    for (const line of lines) {
    //        //console.log(`SpriteThumbnail line:${line}`);
    //        if (line.includes("-->")) {
    //            const [start, end] = line.split("-->").map(s => parseVttTimestamp(s.trim()));
    //            currentStart = start;
    //            thumbnails.push({ start, end, sprite: null });
    //           //console.log(`SpriteThumbnail start:${start}`);
    //        } else if (line.includes("#xywh=")) {
    //            const sprite = parseVttLine(line);
    //            if (sprite && currentStart != null) {
    //                const t = thumbnails[thumbnails.length - 1];
    //                t.sprite = sprite;
    //                //console.log(`SpriteThumbnail sprite.src:${sprite.src}`);
    //                //console.log(`SpriteThumbnail sprite.x:${sprite.x}`);
    //            }
    //        }
    //    }

    //    return thumbnails;
    //}

    //// 00:00:03.000 を 秒数に変換
    //function parseVttTimestamp(ts: string): number {
    //    const [h, m, s] = ts.split(":");
    //    //console.log(`SpriteThumbnail h:${h} m:${m} s:${s} parseFloat(s):${parseFloat(s) }`);
    //    return parseInt(h, 10) * 3600 + parseInt(m, 10) * 60 + parseFloat(s);
    //}

    //const [thumbnails, setThumbnails] = React.useState<any[]>([]);

    //React.useEffect(() => {
    //    loadThumbnails("/api/operations/thumbnails/vtt/timeline/" + props.operationId).then(setThumbnails);
    //}, []);

    //// Timeline にサムネイルをマッピング
    //const [listWithThumbnails, setListTimelineWithThumbnails] = React.useState(null);
    //React.useEffect(() => {
    //    const listWithThumbnails = props.listTimeline.map(item => {
    //        //console.log(`SpriteThumbnail item.time:${item.time}`);
    //        const sec = parseVttTimestamp(item.time); // 00:00:05 → 5秒
    //        const secRe = sec + 0;
    //        //console.log(`SpriteThumbnail sec:${sec} secRe:${secRe}`);
    //        const thumb = thumbnails.find(t => secRe >= t.start && secRe < t.end);

    //        return {
    //            ...item,
    //            thumbnail: thumb
    //                ? {
    //                    src: thumb.sprite.src,
    //                    style: {
    //                        objectFit: "none" as const,
    //                        objectPosition: `-${thumb.sprite.x}px -${thumb.sprite.y}px`,
    //                        width: `${thumb.sprite.w}px`,
    //                        height: `${thumb.sprite.h}px`,
    //                    },
    //                }
    //                : null,

    //            // listTopic がある場合はさらに加工
    //            listTopic: item.listTopic
    //                ? item.listTopic.map(topic => {
    //                    const topicSec = parseVttTimestamp(topic.time);
    //                    const topicThumb = thumbnails.find(
    //                        t => topicSec >= t.start && topicSec < t.end
    //                    );

    //                    return {
    //                        ...topic,
    //                        thumbnail: topicThumb
    //                            ? {
    //                                src: topicThumb.sprite.src,
    //                                style: {
    //                                    objectFit: "none" as const,
    //                                    objectPosition: `-${topicThumb.sprite.x}px -${topicThumb.sprite.y}px`,
    //                                    width: `${topicThumb.sprite.w}px`,
    //                                    height: `${topicThumb.sprite.h}px`,
    //                                },
    //                            }
    //                            : null,
    //                    };
    //                })
    //                : undefined,
    //        };
    //    });

    //    setListTimelineWithThumbnails(listWithThumbnails);
    //}, [props.listTimeline, thumbnails]);

    // Presenterに渡す
    return (
        <Presenter
            {...props}
            //listWithThumbnails={listWithThumbnails}
            fnOnClickButton={fnOnClickButton}
            refTimeline={refTimeline}
        />
    );
};
